import React, { useRef } from 'react';
import '../App.css'; // Reuse global styles

function InviteModal({ isOpen, onClose, inviteText }) {
    const textAreaRef = useRef(null);

    if (!isOpen) return null;

    const handleCopy = () => {
        if (textAreaRef.current) {
            textAreaRef.current.select();
            navigator.clipboard.writeText(textAreaRef.current.value);
            alert('Convite copiado para a área de transferência!');
            onClose();
        }
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 3000 }} onClick={onClose}>
            <div className="modal-content reminder-modal" onClick={e => e.stopPropagation()}>
                <div className="reminder-header" style={{ background: 'linear-gradient(135deg, #00897b, #002a52)' }}>
                    {/* Azul Caneta for Invites */}
                    <h3>📨 Convite Gerado</h3>
                </div>
                <div className="reminder-body">
                    <p>Copie o texto abaixo para enviar:</p>
                    <textarea
                        ref={textAreaRef}
                        value={inviteText}
                        readOnly
                        style={{
                            width: '100%',
                            height: '200px',
                            padding: '10px',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            fontFamily: 'monospace',
                            resize: 'none',
                            backgroundColor: '#f9f9f9'
                        }}
                    />
                </div>
                <div className="reminder-actions">
                    <button className="btn-save" onClick={handleCopy} style={{ backgroundColor: '#00897b' }}>
                        Copiar Convite
                    </button>
                    <button className="btn-cancel" onClick={onClose}>
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InviteModal;
